import React, { useState, useEffect } from "react";
import "./index.scss";
import WalletBalanceCard from "./WalletBalanceCard";
import TransactionTable from "./TransactionTable";
import { Tabs } from "antd";
import balance from "../../assests/images/balance_black.svg";
import Heading from "../../components/Heading";
const Wallet = () => {
  const [reloadTable, setReloadTable] = useState(false);
  const [prospayCustomerId, setProspayCustomerId] = useState(null);
  //const { prospayCustomerId } = useLocation().state;
  useEffect(() => {
    if (history?.state?.usr?.prospayCustomerId) {
      setProspayCustomerId(history?.state?.usr?.prospayCustomerId);
    } else {
      let id =
        JSON.parse(localStorage.getItem("selectedCompany"))
          ?.prospayCustomerId || null;
      setProspayCustomerId(id);
    }
  }, [history?.state]);

  return (
    <div className="master-main-container p-1">
      {history?.state?.usr?.prospayCustomerId ? (
        <Heading
          title="My Wallet"
          navigateTo={history?.state?.usr?.url}
          id={history?.state?.usr?.tabKey}
        />
      ) : (
        <Heading title="My Wallet" />
      )}
      <WalletBalanceCard
        reloadTable={() => setReloadTable(!reloadTable)}
        prospayCustomerId={prospayCustomerId}
      />

      <Tabs
        defaultActiveKey="1"
        className="wallet-tabs mt-2"
        items={[
          {
            key: "1",
            label: (
              <span>
                {" "}
                <img src={balance} alt="balance" className="mr-1" />
                Wallet Transactions
              </span>
            ),
            children: (
              <TransactionTable
                reloadTable={reloadTable}
                prospayCustomerId={prospayCustomerId}
              />
            ),
          },
          // {
          //   key: "2",
          //   label: "Invoice",
          //   children: <p>Invoice</p>,
          // },
        ]}
      />
    </div>
  );
};

export default Wallet;
